var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loading)?_c('v-sheet',_vm._b({class:_vm.getClasses,attrs:{"color":_vm.color}},'v-sheet',_vm.$attrs,false),[_c('v-responsive',{staticClass:"mx-auto",attrs:{"max-width":"100%"}},[_vm._l((_vm.count),function(i){return [_c('v-skeleton-loader',{staticClass:"mx-auto mb-1",attrs:{"type":_vm.type}})]})],2)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }